import Vue from 'vue'

const DialogConstructor = Vue.extend(require('./dialog.vue'))
const instances = []

export default function Dialog(opts) {
  const instance = getInstance()
  const options = opts || {
    title: ''
  }

  instance.title = options.title || ''
  instance.btns = options.btns || [{
    text: '我知道了'
  }]
  instance.code = options.code
  instance.phoneNum = options.phoneNum || ''
  instances.push(instance)
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.open()
  })
}

function getInstance() {
  if (instances.length > 0) {
    const instance = instances[0]
    instances.splice(0, 1)
    return instance
  }

  return new DialogConstructor({
    el: document.createElement('div')
  })
}



// WEBPACK FOOTER //
// ./web/components/captchaDialog/dialog.js